module.exports = __webpack_public_path__ + "media/images/MarcJ-c4aa4e1dcc215ec4a34780ab4d081f95.jpg";